// extracted by mini-css-extract-plugin
module.exports = {"list":"list_layout_list__3Jn3R","inner":"list_layout_inner__j0DGR","title":"list_layout_title__2S5rE","menu":"list_layout_menu__1sI6_","iconMenu":"list_layout_iconMenu__tuKfu"};